import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Toegewijde client, uitsluitend voor ResetWachtwoordPage.jsx.
//
// De gedeelde `supabase`-client (../lib/supabase.js) heeft persistSession:
// true, omdat de normale ingelogde sessie (via AuthContext) dat nodig
// heeft. Een wachtwoord-reset-link levert echter een geauthenticeerde
// recovery-sessie op (incl. refresh-token) — als die via de gedeelde,
// persistente client wordt verwerkt, overleeft hij het afsluiten van het
// tabblad en kan een volgende gebruiker op een gedeeld apparaat de sessie
// hervatten. Deze losse client met persistSession: false gebruikt altijd
// een in-memory storage-adapter (geverifieerd tegen @supabase/auth-js
// GoTrueClient: persistSession=false ⇒ memoryLocalStorageAdapter,
// ongeacht storageKey) — er wordt dus nooit iets naar localStorage
// geschreven en een abrupt gesloten tabblad laat niets bruikbaars achter.
//
// detectSessionInUrl staat hier AAN en op de gedeelde client UIT (zie
// ../lib/supabase.js) — zo is deze client de enige die het
// recovery-hash-fragment verwerkt, en kan de gedeelde, persistente client
// het nooit alsnog (dubbel) oppikken en opslaan.
export const resetSupabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: false,
    detectSessionInUrl: true,
    autoRefreshToken: true,
  },
});
